import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import { FooterData } from '../../Interfaces/FooterInterface';

export const getElementById = (id: string) => {
  return document.getElementById(id);
};

export const getFooterDataByType = (data: FooterData[], footerType: string) => {
  let result;
  if(!_isEmpty(data) &&_isArray(data)) {
    result = data.find((footer: FooterData) => _get(footer, ['footerIdentifier']) === footerType);
  }
  return result;
};

export function setMaxTitleHeight() {
  const titleElements = document.querySelectorAll('.global-footer__title');
  let maxHeight = 0;

  titleElements.forEach((titleElement) => {
    const titleHeight = (titleElement as HTMLElement)?.clientHeight;
    if (titleHeight > maxHeight) {
      maxHeight = titleHeight;
    }
  });

  return maxHeight;
}

export const isCookieLink = (link:any) => {
  return _get(link, ['title']).toLowerCase().includes("cookie");
}

export const getHoriFooterHrefAttr = (link:any) => {
 return !isCookieLink(link) ? _get(link, ['href'], '') : "javascript:OneTrust.ToggleInfoDisplay()";
}